<template>
  <vue-qrcode-base
    v-bind="$attrs"
    :value="value"
    :type="type"
    :color="color"
  />
</template>



<script>
  // Thin wrapper around vue-qrcode v2 (upgraded from v0.3.6 for Vue 3 compatibility).
  // vue-qrcode v2 made `type` and `color` required props, but all existing usages in
  // this codebase relied on the library's implicit defaults. This wrapper provides those
  // defaults so that none of the 20+ consumer components needed to change.
  import VueQrcodeBase from 'vue-qrcode';

  export default {
    name: 'VueQrcode',

    components: {
      VueQrcodeBase
    },

    // Prevent $attrs from falling through to VueQrcodeBase (we forward them explicitly via v-bind).
    inheritAttrs: false,

    props: {
      value: {
        type: [String, Array],
        required: true
      },

      // Provide defaults for props that are required in vue-qrcode v2 but have
      // sensible library defaults. Consumers can override if needed.
      type: {
        type: String,
        default: 'image/png'
      },

      color: {
        type: Object,
        default: () => ({ dark: '#000000ff', light: '#ffffffff' })
      }
    }
  };
</script>
